module.exports = "/images/bg_af83ba.png";